import React from 'react';

export default
<g>
    <g transform="translate(-897.000000, -16.000000)">
        <g transform="translate(863.000000, 16.000000)">
            <path d="M74,20c0-1.6-0.2-3.2-0.5-4.7l-2.8,1.5c0.2,1,0.3,2.1,0.3,3.2c0,9.3-7.3,16.9-16.3,16.9V40
				C65.4,40,74,31.1,74,20 M69.4,20c0-0.9-0.1-1.7-0.2-2.6l-2.6,0.7c0.1,0.6,0.1,1.2,0.1,1.8c0,7-5.9,12.8-12,12.8V35
				C62.8,35,69.4,28.3,69.4,20 M65,13.8l2.4-1.4c-2.5-4.5-7.3-7.5-12.7-7.5v2.6C58.3,7.5,63.2,10.3,65,13.8 M62.4,5.1l1.5-2.7
				C61.2,0.9,58,0,54.7,0v3.1C57.5,3.1,60.1,3.8,62.4,5.1 M53.3,40v-7.3c-6,0-12-5.7-12-12.7S47.5,7.5,53.3,7.5V0
				C42.6,0,34,8.9,34,20S42.6,40,53.3,40"/>
        </g>
    </g>
</g>;
